/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_Exit_ErrorInputs */

const vi_impersonation_exit_error = /** @type {(inputs: Impersonation_Exit_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể thoát chế độ xem. Vui lòng thử lại.`)
};

/**

* @param {Impersonation_Exit_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_exit_error = /** @type {((inputs?: Impersonation_Exit_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_Exit_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_exit_error(inputs)
});